enum AppActionType {
    STORE_SIGN_IN = 'storeSignIn',
    CLEAR_SIGN_IN = 'clearSignIn',
    USE_WORKSPACE = 'useWorkspace',
}

export default AppActionType
